import { render, staticRenderFns } from "./hotThreeAnchorItem.vue?vue&type=template&id=42f6aa66&"
import script from "./hotThreeAnchorItem.vue?vue&type=script&lang=js&"
export * from "./hotThreeAnchorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports